<app-confirmation-dialog
  #copyYardagesDialog
  (confirmed)="onCopyYardagesConfirmed($event)"
  (cancelled)="onCopyYardagesCancelled()"
></app-confirmation-dialog>

<table class="table table-holes">
  <thead>
    <tr class="hole-row">
      <th class="first-column">Hole</th>
      @for (hole of holesOUT; track hole) {
        <th>
          {{ hole.number }}
        </th>
      }
      <th>Out</th>
      @for (hole of holesIN; track hole) {
        <th>
          {{ hole.number }}
        </th>
      }
      <th>In</th>
      <th>Total</th>
    </tr>
  </thead>
  <tbody>
    <!-- Par row -->
    <tr>
      <td class="first-column">Par</td>
      @for (hole of holesOUT; track hole; let idx = $index) {
        <td>
          <input
            #parInput
            type="text"
            inputmode="numeric"
            autocomplete="off"
            maxlength="1"
            pattern="[3-7]"
            [ngModel]="hole.par ?? ''"
            (ngModelChange)="onParModelChange($event, hole, idx)"
            (keydown)="onParKeyDown($event)"
            [readonly]="readOnly"
            />
          </td>
        }
        <td>{{ parTotalOUT }}</td>
        @for (hole of holesIN; track hole; let idx = $index) {
          <td>
            <input
              #parInput
              type="text"
              inputmode="numeric"
              autocomplete="off"
              maxlength="1"
              pattern="[3-7]"
              [ngModel]="hole.par ?? ''"
              (ngModelChange)="onParModelChange($event, hole, holesOUT.length + idx)"
              (keydown)="onParKeyDown($event)"
              [readonly]="readOnly"
              />
            </td>
          }
          <td>{{ parTotalIN }}</td>
          <td>{{ parTotal }}</td>
        </tr>
        <!-- Drive measured row -->
        <tr class="drive-measured-row">
          <td class="first-column">Drive Measured?</td>
          @for (hole of holesOUT; track hole) {
            <td>
              <input
                type="checkbox"
                [(ngModel)]="hole.isDriveMeasured"
                (ngModelChange)="setHoleChanged(hole)"
                [disabled]="readOnly"
                />
              </td>
            }
            <td></td>
            @for (hole of holesIN; track hole) {
              <td>
                <input
                  type="checkbox"
                  [(ngModel)]="hole.isDriveMeasured"
                  (ngModelChange)="setHoleChanged(hole)"
                  [disabled]="readOnly"
                  />
                </td>
              }
            </tr>
            <!-- Round selector row -->
            @if (rounds.length > 0) {
              <tr>
                <td colspan="22" style="text-align: left">
                  <div class="btn-group">
                    <button
                      data-toggle="dropdown"
                      class="btn btn-primary btn-outline dropdown-toggle"
                      >
                      Round {{ selectedRound.number }} <span class="caret"></span>
                    </button>
                    <ul class="dropdown-menu">
                      @for (round of rounds; track round) {
                        <li style="display: flex">
                          <a
                            href="#"
                            (click)="selectRound(round); $event.preventDefault()"
                style="
                  display: flex;
                  justify-content: space-between;
                  width: 100%;
                  align-items: center;
                "
                            >
                            <span>Round {{ round.number }}</span>
                            @if (round.active) {
                              <i class="fa fa-check check-icon"></i>
                            }
                          </a>
                        </li>
                      }
                    </ul>
                  </div>
                </td>
              </tr>
            }
            <!-- Yardage row -->
            @if (holeYardagesOUT.length > 0 && holeYardagesIN.length > 0) {
              <tr>
                <td class="first-column">Yardage</td>
                @for (holeYardage of holeYardagesOUT; track holeYardage) {
                  <td>
                    <input
                      type="number"
                      [(ngModel)]="holeYardage.yardage"
                      (ngModelChange)="setChangedHoleYardage(holeYardage)"
                      [readonly]="readOnly"
                      />
                    </td>
                  }
                  <td>{{ yardageTotalOUT }}</td>
                  @for (holeYardage of holeYardagesIN; track holeYardage) {
                    <td>
                      <input
                        type="number"
                        [(ngModel)]="holeYardage.yardage"
                        (ngModelChange)="setChangedHoleYardage(holeYardage)"
                        [readonly]="readOnly"
                        />
                      </td>
                    }
                    <td>{{ yardageTotalIN }}</td>
                    <td>{{ yardageTotal }}</td>
                  </tr>
                }
              </tbody>
            </table>
